/**
 * 把本次链接解析成实际 packageName，并写入 localStorage 供本次请求和品牌判断读取。
 * 优先级：链接 packageName > 链接 pt > 按域名补 Donia。
 * pt=1 是 Donia，pt=2 是 Zivano；正式或测试由域名决定。
 * 不读取上次留下的 packageName。pt 只认本次链接，不传给接口。
 */
const DONIA_PACKAGE_NAME = 'com.futurefun.live';
const DONIA_DEBUG_PACKAGE_NAME = 'com.cc.cccc.debug';
const ZIVANO_PACKAGE_NAME = 'com.zivano.live';
const ZIVANO_DEBUG_PACKAGE_NAME = 'com.dd.dddd.debug';

let resolvedPackageName: string | undefined;

/** 本次页面解析出的包名。不读 localStorage。 */
export function getResolvedPackageName(): string | undefined {
  return resolvedPackageName;
}
const QUERY_KEYS_RESOLVED_LATER = new Set(['packageName', 'pt']);

function isTestHostname(hostname?: string | null): boolean {
  const host = String(hostname ?? '')
    .trim()
    .toLowerCase();
  return host === 'localhost' || host === '127.0.0.1' || host.includes('test');
}

export function defaultDoniaPackageName(hostname?: string | null): string {
  return isTestHostname(hostname) ? DONIA_DEBUG_PACKAGE_NAME : DONIA_PACKAGE_NAME;
}

function packageNameFromPt(pt: string, hostname?: string | null): string | undefined {
  const test = isTestHostname(hostname);
  if (pt === '1') return test ? DONIA_DEBUG_PACKAGE_NAME : DONIA_PACKAGE_NAME;
  if (pt === '2') return test ? ZIVANO_DEBUG_PACKAGE_NAME : ZIVANO_PACKAGE_NAME;
  return undefined;
}

export function resolvePackageName(source: {
  packageName?: string | null;
  pt?: string | null;
  hostname?: string | null;
}): string {
  const urlName = String(source.packageName ?? '').trim();
  if (urlName) return urlName;

  const mapped = packageNameFromPt(String(source.pt ?? '').trim(), source.hostname);
  if (mapped) return mapped;

  return defaultDoniaPackageName(source.hostname);
}

/**
 * 读取本次 search。packageName / pt 只放进返回值，由解析结果统一写回。
 * 某个值无法解码时跳过该键，其余键继续。
 */
export function absorbSearch(
  search: string,
  storage?: Pick<Storage, 'setItem'>,
): Record<string, string> {
  const query: Record<string, string> = {};
  const queryStr = search.startsWith('?') ? search.slice(1) : search;
  if (!queryStr) return query;

  queryStr.split('&').forEach((item) => {
    const [key, rawVal] = item.split('=');
    if (!key) return;

    let decoded = '';
    try {
      decoded = decodeURIComponent(rawVal ?? '');
    } catch {
      return;
    }

    query[key] = decoded;
    if (!storage || QUERY_KEYS_RESOLVED_LATER.has(key)) return;
    storage.setItem(key, rawVal ?? '');
  });

  return query;
}

export function applyResolvedPackageName(
  query: { packageName?: string | null; pt?: string | null } = window.query ?? {},
  storage: Pick<Storage, 'setItem'> = localStorage,
  hostname: string = window.location.hostname,
): string {
  const resolved = resolvePackageName({
    packageName: query?.packageName,
    pt: query?.pt,
    hostname,
  });
  resolvedPackageName = resolved;
  try {
    storage.setItem('packageName', resolved);
  } catch (error) {
    console.error('packageName storage failed:', error);
  }
  return resolved;
}
